import { Mail, MessageSquare, Phone, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackCallClick } from "@/lib/ga4";
import type { ConversationAlternativePromptProps } from "@/types/voice/conversation-follow-up";

export const ConversationAlternativePrompt = ({ kind, onDismiss, onSwitchToText, phoneNumber, onCall, onEmail, disabled }: ConversationAlternativePromptProps) => (
  <section aria-label={kind === "voice" ? "Connection help" : "Email follow-up"}
    className="relative w-full max-w-md rounded-2xl border border-genie-border bg-white p-4 shadow-sm">
    <button type="button" onClick={onDismiss} aria-label="Dismiss suggestion"
      className="absolute right-1 top-1 flex min-h-[44px] min-w-[44px] items-center justify-center rounded-full text-gray-500 hover:bg-gray-50">
      <X className="h-4 w-4" />
    </button>
    <p className="pr-8 text-sm font-semibold text-[#222B45]" role="status">
      {kind === "voice" ? "Having trouble connecting?" : "Would you like to continue this conversation over email?"}
    </p>
    {kind === "voice" && <p className="mt-1 pr-6 text-sm text-gray-600">{phoneNumber ? "Would you rather call the Genie or continue by text?" : "You can continue by text without a microphone."}</p>}
    <div className="mt-3 flex flex-wrap gap-2">
      {kind === "voice" && phoneNumber && (
        <Button asChild variant="outline" className="min-h-[44px] h-auto whitespace-normal gap-2 text-left">
          <a
            href={`tel:${phoneNumber.replace(/[^\d+]/g, "")}`}
            onClick={() => {
              trackCallClick("conversation_alternative_prompt");
              onCall?.();
            }}
          ><Phone className="h-4 w-4 shrink-0" />Call the Genie · {phoneNumber}</a>
        </Button>
      )}
      {kind === "voice" && onSwitchToText && <Button variant="outline" className="min-h-[44px] gap-2" disabled={disabled} onClick={onSwitchToText}><MessageSquare className="h-4 w-4" />Continue by text</Button>}
      {kind === "email" && onEmail && <Button variant="outline" className="min-h-[44px] gap-2" onClick={onEmail}><Mail className="h-4 w-4" />Continue over email</Button>}
    </div>
  </section>
);
